import { render } from "./SelectCityPopup.vue?vue&type=template&id=0594346b"
import script from "./SelectCityPopup.vue?vue&type=script&lang=js"
export * from "./SelectCityPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__